import { axiosApiInstance } from '@/api/axios'
import calcFeaures from './calcFeaures'

const state = {
  calcCategories: [],
  canvasTypes: [],
  calcDetails: [],
  calcPageLoading: false
}

const getters = {
  calcCategories: (state) => state.calcCategories,
  canvasTypes: (state) => state.canvasTypes,
  calcDetails: (state) => state.calcDetails,
  calcPageLoading: (state) => state.calcPageLoading
}

const mutations = {
  SET_CALC_CATEGORIES(state, payload) {
    state.calcCategories = payload
  },
  SET_CALC_PAGE_LOADING(state, payload) {
    state.calcPageLoading = payload
  },
  SET_CANVAS_TYPES(state, payload) {
    state.canvasTypes = payload
  },
  SET_CALC_DETAILS(state, payload) {
    state.calcDetails = payload
  }
}

const actions = {
  fetchCalcCategories({ commit }) {
    commit('SET_CALC_PAGE_LOADING', true)
    axiosApiInstance
      .get('/api/public/calculator_categories')
      .then((res) => {
        const catIcons = [
          {
            icon: 'fal fa-door-closed',
            id: 1
          },
          {
            icon: 'far fa-layer-group',
            id: 2
          },
          {
            icon: 'far fa-layer-group',
            id: 13
          },
          {
            icon: 'fal fa-door-closed',
            id: 3
          },
          {
            icon: 'far fa-fill-drip',
            id: 4
          },
          {
            icon: 'far fa-fill-drip',
            id: 14
          },
          {
            icon: 'fas fa-door-open',
            id: 5
          },
          {
            icon: 'fal fa-ruler-vertical',
            id: 6
          },
          {
            icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--radix-icons" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 15 15"><path fill="currentColor" fill-rule="evenodd" d="M3 2.739a.25.25 0 0 1-.403.197L1.004 1.697a.25.25 0 0 1 0-.394L2.597.063A.25.25 0 0 1 3 .262v.74h6V.26a.25.25 0 0 1 .404-.197l1.592 1.239a.25.25 0 0 1 0 .394l-1.592 1.24A.25.25 0 0 1 9 2.738V2H3v.739ZM9.5 5h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm-7-1A1.5 1.5 0 0 0 1 5.5v7A1.5 1.5 0 0 0 2.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 9.5 4h-7Zm12.239 2H14v6h.739a.25.25 0 0 1 .197.403l-1.239 1.593a.25.25 0 0 1-.394 0l-1.24-1.593a.25.25 0 0 1 .198-.403H13V6h-.739a.25.25 0 0 1-.197-.403l1.239-1.593a.25.25 0 0 1 .394 0l1.24 1.593a.25.25 0 0 1-.198.403Z" clip-rule="evenodd"></path></svg>',
            svg: true,
            id: 15
          },
          {
            icon: 'fal fa-pencil-ruler',
            id: 7
          },
          {
            icon: 'fal fa-unlock-alt',
            id: 8
          },
          {
            icon: 'fal fa-exchange-alt',
            id: 9
          },
          {
            icon: 'fal fa-eye',
            id: 10
          },
          {
            icon: 'fal fa-lock-alt',
            id: 11
          },
          {
            icon: 'fal fa-door-open',
            id: 12
          },
          {
            icon: 'fas fa-shipping-fast',
            id: 'deliveryFront'
          },
          {
            icon: 'fas fa-tools',
            id: 'installationFront'
          },
          {
            icon: 'far fa-sort-numeric-down',
            id: 'quantityFront'
          },
          {
            icon: 'fas fa-envelope',
            id: 'messageFront'
          }
        ]
        const addedCategories = [
          {
            id: 1,
            sort: 1,
            name_en: 'Type of canvas',
            name_ru: 'Вид полотна',
            name_uz: 'Tuval turi'
          },
          {
            id: 'deliveryFront',
            sort: 16,
            name_en: 'Delivery',
            name_ru: 'Доставка',
            name_uz: 'Yetkazib berish'
          },
          {
            id: 'installationFront',
            sort: 17,
            name_en: 'Installation',
            name_ru: 'Установка',
            name_uz: "O'rnatish"
          },
          {
            id: 'quantityFront',
            sort: 18,
            name_en: 'Quantity',
            name_ru: 'Количество',
            name_uz: 'Miqdor'
          },
          {
            id: 'messageFront',
            sort: 19,
            name_en: 'Message',
            name_ru: 'Примечание',
            name_uz: 'Xabar'
          }
        ]
        let calcCategoriesWithIcons = []
        for (const icon of catIcons) {
          for (const category of [...addedCategories, ...res.data].sort(
            (a, b) => parseInt(a.sort) - parseInt(b.sort)
          )) {
            if (category.id === icon.id) {
              calcCategoriesWithIcons.push({
                id: category.id,
                sort: category.sort,
                name_en: category.name_en,
                name_ru: category.name_ru,
                name_uz: category.name_uz,
                icon: icon.icon,
                svg: icon.svg || false
              })
            }
          }
        }
        commit(
          'SET_CALC_CATEGORIES',
          calcCategoriesWithIcons.filter((cat) => cat.id !== 1)
        )
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_CALC_PAGE_LOADING', false)
        }, 500)
      })
  },
  fetchCalcDetailsWithCanvas({ commit, dispatch }, canvas_id) {
    axiosApiInstance
      .get('/api/public/get_calc_details_with_canvas', {
        params: { canvas_id }
      })
      .then((res) => {
        let data = res.data
        const results = data.reduce((results, org) => {
          ;(results[org.calc_cat_id] = results[org.calc_cat_id] || []).push(org)
          return results
        }, {})
        commit('SET_CALC_DETAILS', results)
        const patternType = results[2][0]
        const exteriorPatternType = results[13][0]
        const frame = results[3][0]
        dispatch('calcFeaures/setDoorPatternType', patternType)
        dispatch('calcFeaures/setDoorExteriorPatternType', exteriorPatternType)
        dispatch('calcFeaures/setDoorFrame', frame)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  fetchCanvasTypes({ commit, dispatch }) {
    axiosApiInstance
      .get('/api/public/get_canvas')
      .then((res) => {
        commit('SET_CANVAS_TYPES', res.data)
        dispatch('fetchCalcDetailsWithCanvas', res.data[0].id)
      })
      .catch((err) => console.log(err))
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  modules: {
    calcFeaures
  }
}
